import _ from "lodash"

const jsMessages = window.jsMessages
const messagesArray =
  jsMessages &&
  _.map(jsMessages.messages, (message, key) => {
    return { key, message }
  })

export function getMessage(key, category) {
  if (!jsMessages) {
    return key
  }

  if (key) {
    if (category) {
      const fullKey = category + "." + key
      const msg = jsMessages(fullKey)
      if (msg !== fullKey) {
        return msg
      } else {
        const result = _.chain(messagesArray)
          .filter((m) => m.key.startsWith(category + ".") && m.key.endsWith("." + key))
          .map((m) => jsMessages(m.key))
          .value()

        if (result && result.length > 0) {
          return result[0]
        }
      }
    }

    return jsMessages(key)
  } else {
    return null
  }
}

export function enumMessages(category, includeUnknown) {
  if (!jsMessages) {
    return []
  }

  const prefix = category + "."
  return _.chain(messagesArray)
    .filter((m) => m.key.startsWith(prefix))
    .map((m) => {
      m.value = m.key.replace(prefix, "")
      m.index = m.value
      if (m.value.indexOf(".") > 0) {
        m.index = m.value.substr(0, m.value.indexOf("."))
        m.value = m.value.substr(m.index.length + 1)
      }
      return m
    })
    .filter((m) => (includeUnknown ? m.index > -1 : m.index > 0))
    .sortBy(["index"])
    .value()
}

export function fuzzyGetMessage(category, key, returnObj = false) {
  const fullKey = `${category}.${key}`
  if (key) {
    if (!jsMessages) {
      return fullKey
    }

    const result = _.chain(messagesArray)
      .filter((m) => m.key.indexOf(fullKey) > -1)
      .value()
    if (result && result.length > 0) {
      if (returnObj) {
        return result[0]
      }
      return jsMessages(result[0].key)
    }
    return fullKey
  }
  return null
}
